<template>
		<div class="tabWrapper vacationWrapper">
			<div class="vacationNav">
				<button @click="changeYear(-1)"><svg-sprite icon-id="arrow_left" width="20" height="20"></svg-sprite></button>
				<span>{{ currentYear }}</span>
				<button @click="changeYear(1)"><svg-sprite icon-id="arrow_right" width="20" height="20"></svg-sprite></button>
			</div>
			<div class="workTableMain" v-if="calendarEventsList">
				<calendar-events-month
						v-for="(item, index) in calendarEventsList"
						:key="index"
						:item="item"
				></calendar-events-month>
			</div>
		</div>
	</template>

<script>
import { mapActions, mapGetters } from "vuex";
import CalendarEventsMonth from "@/pages/Account/Tabs/CalendarEventsMonth/CalendarEventsMonth.vue";

export default {
	name: "AccountTabCalendarEvents",
	components: { CalendarEventsMonth },
	props: {},
	computed: {
		...mapGetters([
			'calendarEventsList', // Исходный список отпусков из Vuex
		]),
		currentYear() {
			return this.selectedYear;
		}
	},
	data() {
		return {
			selectedYear: new Date().getFullYear(), // Текущий год по умолчанию
		};
	},
	methods: {
		...mapActions([
			'getCalendarEventsList', // Экшен для получения данных из Vuex
		]),
		async changeYear(direction) {
			this.selectedYear += direction; // Изменяем год на следующий или предыдущий
			await this.getCalendarEventsList({ year: this.selectedYear }); // Передаем год в экшен
		}
	},
	async mounted() {
		await this.getCalendarEventsList(); // Загружаем данные при монтировании компонента
	},
};
</script>

	<style scoped lang="scss">
	.tabWrapper {
		padding: 10px 0;
	}
	.workTableMain {
		display: grid;
		//grid-template-columns: 24% 24% 24% 24%;
		grid-template-columns: 1fr 1fr 1fr 1fr ;
		grid-gap: 10px;
		@media screen and (max-width: 1300px) {
			grid-template-columns:  1fr 1fr 1fr;
		}
		@media screen and (max-width: 1000px) {
			grid-template-columns:  1fr 1fr;
		}
		@media screen and (max-width: 768px) {
			grid-template-columns:  1fr;
		}
		div:nth-child(1),
		div:nth-child(2),
		div:nth-child(12) {
			background: rgb(255 255 255 / 5%)
		}
		div:nth-child(3),
		div:nth-child(4),
		div:nth-child(5) {
			background: rgba(0, 140, 255, 0.10);
		}
		div:nth-child(6),
		div:nth-child(7),
		div:nth-child(8) {
			background: rgba(0, 128, 0, 0.12);
		}
		div:nth-child(9),
		div:nth-child(10),
		div:nth-child(11) {
			background: rgba(255, 255, 0, 0.05);
		}
	}
	.vacationNav {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 20px;
		gap: 10px;
		> span {
			font-weight: bold;
			font-size: 16px;
		}
		button {
			color: white;
			border: none;
			padding: 5px 10px;
			cursor: pointer;
			border-radius: 4px;
			font-size: 16px;
			transition: 0.2s;
		}
		button:hover {
			color: #1dab39;
		}
	}

	</style>

